// socketService.js
import { io } from "socket.io-client";
import { SOCKET_URL } from "../appConstants";
// console.log("SOCKET_URL:", SOCKET_URL);

export const socket = io(SOCKET_URL, {
    autoConnect: false, // Prevents multiple connections
    reconnection: true,         // Enable auto-reconnection
    reconnectionAttempts: Infinity,   // Try reconnecting 10 times
    transports: ["websocket"],  // Use WebSocket for a stable connection
    reconnectionDelay: 1000,
    timeout: 20000,
});

